export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center pt-20 md:pt-24 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/30"></div>
      <div className="absolute top-0 right-0 w-2/3 h-full opacity-[0.06]">
        <div className="absolute top-10 right-10 w-64 h-64 rounded-full bg-primary-400 blur-3xl"></div>
        <div className="absolute bottom-20 right-40 w-80 h-80 rounded-full bg-accent-400 blur-3xl"></div>
        <div className="absolute top-1/2 right-20 w-48 h-48 rounded-full bg-primary-300 blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-5">
              <i className="ri-fire-fill text-sm"></i>
              <span>热播剧</span>
              <span className="w-1 h-1 rounded-full bg-accent-400"></span>
              <span>最新更新</span>
              <span className="w-1 h-1 rounded-full bg-accent-400"></span>
              <span>高清画质</span>
            </div>

            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              夜猫影院
              <span className="block md:inline text-foreground-700"> — </span>
              <span className="text-primary-600">熬夜追剧不缓冲</span>
              <span className="block text-xl md:text-2xl lg:text-3xl text-foreground-600 mt-2">
                全集免费在线看
              </span>
            </h1>

            <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-6 max-w-xl lg:max-w-none mx-auto lg:mx-0">
              深夜不孤单，好剧陪你到天亮。夜猫影院汇集海量最新电视剧全集、热播剧完整版资源，高清画质在线播放，追剧全程无缓冲。
              每日更新热门剧集，覆盖国产剧、韩剧、美剧、日剧等多类型，无论你喜欢悬疑烧脑还是甜宠治愈，这里都有你的深夜专属片单。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7">
              <div className="flex items-center gap-1.5 text-sm text-foreground-600">
                <i className="ri-checkbox-circle-fill text-primary-500 text-base"></i>
                <span>每日更新 <strong className="text-foreground-900">30+</strong> 剧集</span>
              </div>
              <div className="flex items-center gap-1.5 text-sm text-foreground-600">
                <i className="ri-checkbox-circle-fill text-primary-500 text-base"></i>
                <span>全集免费 <strong className="text-foreground-900">无广告</strong></span>
              </div>
              <div className="flex items-center gap-1.5 text-sm text-foreground-600">
                <i className="ri-checkbox-circle-fill text-primary-500 text-base"></i>
                <span><strong className="text-foreground-900">1080P</strong> 高清画质</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => scrollTo('index')}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-play-circle-fill mr-2"></i>立即追剧
              </button>
              <button
                onClick={() => scrollTo('topics')}
                className="w-full sm:w-auto px-8 py-3 bg-background-100 text-foreground-700 font-medium text-sm rounded-lg hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap border border-background-200/70"
              >
                <i className="ri-chat-3-line mr-2"></i>热门话题
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-200/40 via-accent-200/30 to-primary-100/40 rounded-2xl blur-xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20night%20scene%20with%20a%20large%20glowing%20screen%20displaying%20vibrant%20colorful%20movie%20posters%20and%20TV%20show%20thumbnails%2C%20cozy%20dark%20room%20with%20warm%20orange%20and%20amber%20ambient%20lighting%2C%20a%20curled%20cat%20sleeping%20on%20a%20cushion%20nearby%2C%20stylized%20modern%20flat%20illustration%20style%2C%20rich%20warm%20tones%2C%20clean%20composition%2C%20streaming%20entertainment%20aesthetic%2C%20night%20owl%20cozy%20vibe%2C%20soft%20bokeh%20light%20effects&width=800&height=600&seq=hero-main-visual&orientation=landscape"
                alt="夜猫影院 - 深夜追剧主视觉"
                className="relative w-full h-auto rounded-2xl object-cover"
                width="800"
                height="600"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}